<div class="row">
  <div class="col">
    <div class="wccard p-3 text-webbtree-green mb-1 pointer" (click)="backEvent()">
      <i class="fa-solid fa-arrow-left"></i> Back
    </div>
    <div class="insights-sidebar">
      <div class="text-center">
        <img style="width: 87px; height: 76px;" src="../../../assets/ai-insights-sidebar.png" class="img-fluid mb-2" alt="">
        <p class="font-weight-600 f-16 mb-1">
          While we source your results,
        </p>
        <p class="text-9696 f-14">
          learn more on what’s next with Webbtree Autopilot<sup><span>AI</span></sup> Talent
        </p>
      </div>

<!-- Include FontAwesome -->

<div class="feature-list">
  <div class="feature-item" (click)="learnMoreDetails()">
    <span class="icon">
      <i class="fa-solid fa-user"></i>
    </span>
    <span class="text">Review Webbtree Autopilot<sup><span>AI</span></sup> Recommended Candidates</span>
    <span class="external-link text-webbtree-green"><i class="fa-solid fa-arrow-up-right-from-square"></i></span>
  </div>

  <div class="feature-item" (click)="learnMoreDetails()">
    <span class="icon">
      <i class="fa-solid fa-phone"></i>
    </span>
    <span class="text">Build Your Shortlist and Unlock Contact Info</span>
    <span class="external-link text-webbtree-green"><i class="fa-solid fa-arrow-up-right-from-square"></i></span>
  </div>

  <div class="feature-item" (click)="learnMoreDetails()">
    <span class="icon">
      <i class="fa-solid fa-envelope"></i>
    </span>
    <span class="text">Reach Out through Targeted Email Campaigns</span>
    <span class="external-link text-webbtree-green"><i class="fa-solid fa-arrow-up-right-from-square"></i></span>
  </div>

  <div class="feature-item" (click)="learnMoreDetails()">
    <span class="icon">
      <i class="fa-solid fa-magnifying-glass"></i>
    </span>
    <span class="text">Fine-Tune Search with Updated Sourcing Criteria</span>
    <span class="external-link text-webbtree-green"><i class="fa-solid fa-arrow-up-right-from-square"></i></span>
  </div>

  <div class="feature-item" (click)="learnMoreDetails()">
    <span class="icon">
      <i class="fa-solid fa-users"></i>
    </span>
    <span class="text">Expand Pool by Requesting More Candidates</span>
    <span class="external-link text-webbtree-green"><i class="fa-solid fa-arrow-up-right-from-square"></i></span>
  </div>
</div>



    </div>

  </div>
</div>



<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
